import { ReactNode } from 'react';
import SlidingPane from 'react-sliding-pane';
import styled from 'styled-components';

export const SlidingPaneStyled = styled(SlidingPane)(
  ({ theme }) => `
    margin-top: ${theme.topFixedHeaderHeight}px;
    overflow: scroll;
    height: calc(100vh - ${theme.topFixedHeaderHeight}px);
  `
);

interface IconWrapperProps {
  children?: ReactNode;
  onClick?: any;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  position: absolute;
  top: 20px;
  right: 30px;
  cursor: pointer;
`;
